import { getEtag } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useBlocker } from 'react-router'

const TEN_MINUTE_INTERVAL = 60 * 10 * 1000

const RouteReloader: React.FC = () => {
  const [initialEtag, setInitialEtag] = useState<string>()
  const { data } = useQuery({
    queryKey: ['getEtag'],
    queryFn: () => getEtag(),
    // We will use both stale time and the refetch interval
    // Stale time: Used for the refetch on window focus, so if the user has been away for 10 minutes
    // upon revisiting the tab, data will be refetched
    // Refetch interval: This only runs when you are active on the page, so if you are on the page for 10 minutes
    // the app will refetch in order to update the app.
    staleTime: TEN_MINUTE_INTERVAL,
    refetchInterval: TEN_MINUTE_INTERVAL,
    refetchOnWindowFocus: true, // This will only run if data is stale
  })

  useEffect(() => {
    setInitialEtag(initialValue => (!initialValue ? data : initialValue))
  }, [data])

  const hasEtagChanged = !!initialEtag && !!data && initialEtag !== data
  const navBlocker = useBlocker(hasEtagChanged)

  useEffect(() => {
    if (navBlocker.state === 'blocked') {
      window.location.replace(navBlocker.location.pathname + navBlocker.location.search)
    }
  }, [navBlocker])

  return null
}

export default RouteReloader
